import script from "./ProjectListTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectListTable.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectListTable.vue?vue&type=style&index=0&id=27f00b6c&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27f00b6c"]])

export default __exports__